import { type StateCreator } from 'zustand';
import { MODAL_NAMES } from '@/constants';

export type ModalNames = keyof typeof MODAL_NAMES

export type ModalSliceActions = {
    openModal: (modalName: ModalNames) => void;
    closeModal: (modalName: ModalNames) => void;
    getModals: () => ModalNames[];
    getCurrentModal: () => ModalNames;
    resetModals: () => void;
}

export type ModalSliceState = {
    modals: ModalNames[]
}

const initialState: ModalSliceState = {
    modals: []
};

export const ModalSlice: StateCreator<
    ModalSliceActions & ModalSliceState,
    [['zustand/devtools', never]],
    [],
    ModalSliceActions & ModalSliceState
> = (set, get) => ({
    ...initialState,
    openModal: (modalName) => {
        const { modals } = get();

        // Ensure a re-render does not add another modal of the same type
        if (!modals.find(modal => modal === modalName)) {
            set({ modals: [...modals, modalName] }, undefined, 'ModalsSlice/openModal');
        }
    },
    closeModal: (modalName) => {
        const { modals } = get();
        set({ modals: modals.filter(modal => modal !== modalName) }, undefined, 'ModalsSlice/closeModal');
    },
    resetModals: () => set(initialState, undefined, 'ModalsSlice/resetModals'),
    getModals: () => {
        const { modals } = get();
        return modals;
    },
    getCurrentModal: () => {
        const { modals } = get();
        return modals?.[0] || [];
    }
});
